export default __webpack_public_path__ + "static/media/logoDark.4bb551fe.svg";